module.exports = __webpack_public_path__ + "img/top-left.cb9fa07.jpg";